import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { isEmpty } from '@ember/utils';
import RSVP from 'rsvp';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validatePresence } from 'ember-changeset-validations/validators';

const fundGroupValidation = {
  name: validatePresence({ presence: true, message: "Can't be blank" }),
};

export default Route.extend({
  fundsService: service(),
  navbarSettings: service(),
  storeCache: service(),
  store: service(),

  beforeModel() {
    return this.fundsService.confirmValidFundToken();
  },

  model() {
    let fundGroupModel = this.modelFor('admin.fund-groups.fund-group');
    let fundGroup = get(fundGroupModel, 'fundGroup');
    if (isEmpty(fundGroup)) {
      set(this, 'navbarSettings.title', 'Add Fund Group');
      fundGroup = this.store.createRecord('admin/fund-group');
    } else {
      set(this, 'navbarSettings.title', 'Edit Fund Group');
    }
    return RSVP.hash({
      record: fundGroup,
      changeset: new Changeset(
        fundGroup,
        lookupValidator(fundGroupValidation),
        fundGroupValidation,
      ),
      roleOptions: this.storeCache.findAll('admin/role').then((roles) => {
        let options = [];
        roles.forEach((role) => {
          if (get(role, 'name') !== 'Org-Admin') {
            let roleName = get(role, 'name');
            options.push({
              label: roleName,
              val: roleName,
            });
          }
        });
        return options.sort().unshift({
          label: "User's Default Role",
          val: '',
        });
      }),
    });
  },
});
